import { render, staticRenderFns } from "./DefaultToolbar.vue?vue&type=template&id=fae424e2&"
import script from "./DefaultToolbar.vue?vue&type=script&lang=js&"
export * from "./DefaultToolbar.vue?vue&type=script&lang=js&"
import style0 from "./DefaultToolbar.vue?vue&type=style&index=0&id=fae424e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports